import { Typography } from '@/components/Typography/Typography';
import { clsx } from 'clsx';

type TabsComponentProps = {
  tabsContent: {
    id: number;
    title: string;
    description: string;
    img: string;
    mobileImg: string;
  }[];
  handleSelectTab: (id: number) => void;
  selectedTab: number;
};
export const TabsComponent = ({
  tabsContent,
  handleSelectTab,
  selectedTab,
}: TabsComponentProps) => {
  return (
    <div className="w-full bg-white">
      <div className="flex justify-between lg:px-24.5-vw lg:flex-row flex-col">
        {tabsContent.map((el) => {
          return (
            <div
              key={el.id}
              className={clsx(
                selectedTab !== el.id && 'opacity-30 hover:opacity-85 cursor-pointer',
                'lg:max-w-[21.25vw] transition'
              )}
              onClick={() => handleSelectTab(el.id)}
            >
              <div
                className={clsx(
                  selectedTab === el.id ? 'bg-ebony' : 'lg:bg-white bg-gray-300',
                  'lg:h-0.7 h-0.7'
                )}
              />
              <div className="flex flex-col gap-1.5 max-lg:px-4 lg:my-10 my-6">
                <Typography $type="PMedium" $weight="700" className="font-formula">
                  {el.title}
                </Typography>
                <Typography $type="PMedium" $weight="400" className="font-jamjuree opacity-70">
                  {el.description}
                </Typography>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
